import { createSelector, Selector } from 'reselect';
import { State } from '../../../store/reducers';
import { selectProjectProjection } from '../project/projectProjection.selector';
import { projectCbsIsValid } from '../../../domain/checks/project/projectCbsIsValid';

export const selectProjectCbsIsValid: Selector<State, boolean> = createSelector(
  [selectProjectProjection],
  (project) => project !== undefined && projectCbsIsValid(project.cuttedBuiltSurface)
);
